import * as React from 'react';
import './ListItem.css';

export interface IListItemProps {
  title: string;
  detail: string;
  detail2?: string;
  notif?: number;
  leftIcoClass?: string;
  icoClass?: string;
  fontClass?: string;
  onClick: (ev: React.MouseEvent<HTMLDivElement>) => void;
}

export const ICO_USER = 'ico_user';
export const ICO_PASSWORD = 'ico_password';

// declare var Waves: any;

class ListItem extends React.Component<IListItemProps, object> {

  /*public componentDidMount() {
    Waves.attach('.ListItem img', 'waves-light');
  }*/

  public render() {
    const { title, detail, detail2, onClick } = this.props;

    let icoClass = this.props.icoClass;
    if (icoClass === undefined) {
      icoClass = '';
    }

    return (
      <div className="listItem" onClick={onClick}>
        {this.props.leftIcoClass &&
          <div className={'listItemLeftIco ' + this.props.leftIcoClass} />
        }
        <div className={'listItemFirstCol ' + this.props.fontClass}>
          <label>{title}</label>
          <label>{detail}</label>
          {this.props.detail2 &&
            <label>{detail2}</label>
          }
        </div>
        <div className={'listItemSecondCol ' + icoClass} />
      </div >
    );
  }
}

export default ListItem;


// WEBPACK FOOTER //
// ./src/components/ListItem.tsx